import script from "./AdministratorProjectFormStep9.vue?vue&type=script&setup=true&lang=js"
export * from "./AdministratorProjectFormStep9.vue?vue&type=script&setup=true&lang=js"

import "./AdministratorProjectFormStep9.vue?vue&type=style&index=0&id=e57fce80&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e57fce80"]])

export default __exports__